import { render, staticRenderFns } from "./ContasBancarias.vue?vue&type=template&id=2fedf3da&scoped=true&"
import script from "./contasBancarias.js?vue&type=script&lang=js&"
export * from "./contasBancarias.js?vue&type=script&lang=js&"
import style0 from "./ContasBancarias.vue?vue&type=style&index=0&id=2fedf3da&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fedf3da",
  null
  
)

export default component.exports